import {resolveRecordTextColor} from "../../helpers/header-item-style.helper";

/**
 * The colours of a row header in the legacy grid (`abstract-ha-timeline.view.ts`, `ha-user.view.ts`): the record
 * colour as background, or the grid's own row colour, and the record's text colour (feature plan 0074) — only on
 * the record's own colour; `undefined` keeps the inherited text colour.
 */
export function legacyRowHeaderColorStyle(rowHeader: {color?: string | null, entity: {textColor?: string | null} | null}): {backgroundColor: string, color: string | undefined} {
    return {
        backgroundColor: rowHeader.color ?? `var(--row__header-background-color)`,
        color: resolveRecordTextColor(rowHeader.color ?? null, rowHeader.entity?.textColor ?? null),
    };
}

/** The colours of an issue cell in the legacy grid: the issue type's colour and its text colour (feature plan 0074). */
export function legacyIssueCellColorStyle(type: {color?: string | null, textColor?: string | null}): {background: string | undefined, color: string | undefined} {
    return {
        background: type.color ?? undefined,
        color: resolveRecordTextColor(type.color ?? null, type.textColor ?? null),
    };
}
